<template>
  <div class="d-flex flex-fill flex-column scrollable">
    <b-toast id="dbinfo" title="Getting started" static no-auto-hide></b-toast>
    <!-- main UI -->
    <div class="row d-flex flex-fill scrollable">
      <div class="row-1 col-2 d-flex flex-fill scrollable" style="max-height: 100%">
        <div class="d-flex flex-column">
          <div class="row-6" style="max-height: 100%">
            <TableColumns></TableColumns>
          </div>
          <span class="thick">Example</span>
          <div class="row-6 pre-scrollable" style="max-height: 30%">
            <Example></Example>
          </div>
        </div>
      </div>

      <div class="col-9">
        <PlanToText />
        <!-- <TreeView /> -->
        <!-- <Modal /> -->
        <QA />
        <!-- <QueryPoem /> -->
      </div>
    </div>
  </div>
</template>

<script>
import PlanToText from './PlanToText.vue'
import QA from './QA.vue'
// import TreeView from './TreeView.vue'
import TableColumns from './TableColumns.vue'
// import QueryPoem from './QueryPoem.vue'

import Example from './Example.vue'
// import Modal from './modal.vue'

export default {
  data: function () {
    return {
      // dbinfo: "You've been connected to the TPCH database. To switch between this and the IMDB database, click 'Switch DB' in the navigation bar. Your preference will be saved for furture access.",
      showOverlay: true
    }
  },
  components: {
    PlanToText,
    QA,
    // TreeView,
    TableColumns,
    Example
    // QueryPoem
    // Modal
  }
}
</script>
